import { Form, Button } from 'react-bootstrap';
import { IoMdAdd } from 'react-icons/io';
import MainCard from '../../../components/MainCard';
import { CategoryTable } from './CategoryTable';
import { IoSearch } from 'react-icons/io5';
import { useEffect, useState } from 'react';
import { AddCategoryPopup } from './AddCategoryPopup';
import { useDispatch, useSelector } from 'react-redux';
import { GlobalMenuForm } from './GloablMenuForm';
import { fetchCategory } from '../../../store/slices/category/categoryThunk';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { selectedCategory } from '../../../store/slices/category/categorySlice';
import { fetchGlobalMenu } from '../../../store/slices/globalMenu/globalMenuThunk';
import { usePermission } from '../../../hooks/usePermission';
import { PERMISSIONS } from '../../../permissions/permissions';

export function CategoryList() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const globalMenu = useSelector((state) => state.globalMenu);
  const category = useSelector((state) => state.category);
  const dispatch = useDispatch();
  const { currentLanguage } = useSelector((state) => state.language);
  const { t } = useTranslation();
  const canAddCategory = usePermission(PERMISSIONS.CATEGORY.CREATE);
    const [search, setSearch] = useState("");

  // Calling Menu API
  useEffect(() => {
    
    if (!globalMenu.currentGlobalMenu) {
      dispatch(fetchGlobalMenu());
    }
  }, [dispatch]);

  useEffect(() => {
    if (!category.categories) {
      fetchCategoryAPI();
    }
  }, [currentLanguage]);

  const fetchCategoryAPI = () => {
    dispatch(fetchCategory());
  };

  const editCategory = (item) => {
    dispatch(selectedCategory(item));
    setShow(true);
  };

  return (
    <>
      {globalMenu.currentGlobalMenu !== null ? (
        <MainCard
          className="table-card"
          title={
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mt-3 mb-4">
              {/* Search Bar */}
              <div className="position-relative" style={{ maxWidth: '300px' }}>
                <IoSearch size={20} className="position-absolute top-50 translate-middle-y text-muted" style={{ left: '15px' }} />
                <Form.Control
                onChange={(e) => setSearch(e.target.value)}
                 type="text" placeholder={t('menu_management.category.search_category')} style={{ paddingLeft: '40px' }} />
              </div>

              {/* Add Category Button */}
              {canAddCategory && (
                <Button variant="outline-dark" style={{ fontWeight: '800' }} onClick={() => setShow(true)}>
                  <IoMdAdd size={20} className="me-2" />
                  {t('menu_management.category.addCategory')}
                </Button>
              )}
            </div>
          }
        >
          {/* Category Table */}
          <CategoryTable fetchCategory={fetchCategoryAPI} editCategory={editCategory} search={search} />

          <AddCategoryPopup show={show} handleClose={handleClose} fetchCategory={fetchCategoryAPI} />
        </MainCard>
      ) : (
        <GlobalMenuForm />
      )}
    </>
  );
}
